import template from './editLink.html' with { type: 'html' };

export default {
	name: 'CEditLink',
	props: {
		eventName: {
			type: String,
			required: true // E.g. => 'editBilling'
		},
		linkPath: {
			type: String,
			required: true // E.g. => 'shopping-cart'
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	methods: {
		trackEvent(event) {
			this.tracking[event]({
				url: this.url,
				page: this.page,
				order: this.order,
				theme: this.theme
			});
		}
	},
	template
};
